import React from "react";

function Instagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64865 9.00002C5.64865 6.87295 7.37295 5.14865 9.50002 5.14865C11.6271 5.14865 13.3514 6.87295 13.3514 9.00002C13.3514 11.1271 11.6271 12.8513 9.50002 12.8513C7.37295 12.8513 5.64865 11.1271 5.64865 9.00002ZM9.50001 11.5C8.11928 11.5 7 10.3807 7 9.00002C7 7.61928 8.11928 6.5 9.50001 6.5C10.8807 6.5 12 7.61928 12 9.00002C12 10.3807 10.8807 11.5 9.50001 11.5Z"
        fill="url(#paint0_linear_192_5983)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64865 9.00002C5.64865 6.87295 7.37295 5.14865 9.50002 5.14865C11.6271 5.14865 13.3514 6.87295 13.3514 9.00002C13.3514 11.1271 11.6271 12.8513 9.50002 12.8513C7.37295 12.8513 5.64865 11.1271 5.64865 9.00002ZM9.50001 11.5C8.11928 11.5 7 10.3807 7 9.00002C7 7.61928 8.11928 6.5 9.50001 6.5C10.8807 6.5 12 7.61928 12 9.00002C12 10.3807 10.8807 11.5 9.50001 11.5Z"
        fill="url(#paint1_radial_192_5983)"
      />
      <path
        d="M13.5035 5.89648C14.0006 5.89648 14.4035 5.49355 14.4035 4.99649C14.4035 4.49943 14.0006 4.09647 13.5035 4.09647C13.0065 4.09647 12.6035 4.49943 12.6035 4.99649C12.6035 5.49355 13.0065 5.89648 13.5035 5.89648Z"
        fill="url(#paint2_linear_192_5983)"
      />
      <path
        d="M13.5035 5.89648C14.0006 5.89648 14.4035 5.49355 14.4035 4.99649C14.4035 4.49943 14.0006 4.09647 13.5035 4.09647C13.0065 4.09647 12.6035 4.49943 12.6035 4.99649C12.6035 5.49355 13.0065 5.89648 13.5035 5.89648Z"
        fill="url(#paint3_radial_192_5983)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50002 1.5C7.46312 1.5 7.20771 1.50863 6.40776 1.54513C5.60947 1.58154 5.06427 1.70834 4.58722 1.89376C4.09402 2.08539 3.67577 2.34184 3.25879 2.75879C2.84184 3.17577 2.58539 3.59402 2.39376 4.08722C2.20834 4.56427 2.08154 5.10947 2.04513 5.90776C2.00863 6.70771 2 6.96312 2 9.00002C2 11.0369 2.00863 11.2923 2.04513 12.0922C2.08154 12.8905 2.20834 13.4357 2.39376 13.9128C2.58539 14.406 2.84184 14.8242 3.25879 15.2412C3.67577 15.6582 4.09402 15.9146 4.58722 16.1063C5.06427 16.2917 5.60947 16.4185 6.40776 16.4549C7.20771 16.4914 7.46312 16.5 9.50002 16.5C11.5369 16.5 11.7923 16.4914 12.5922 16.4549C13.3905 16.4185 13.9357 16.2917 14.4128 16.1063C14.906 15.9146 15.3242 15.6582 15.7412 15.2412C16.1582 14.8242 16.4146 14.406 16.6063 13.9128C16.7917 13.4357 16.9185 12.8905 16.9549 12.0922C16.9914 11.2923 17 11.0369 17 9.00002C17 6.96312 16.9914 6.70771 16.9549 5.90776C16.9185 5.10947 16.7917 4.56427 16.6063 4.08722C16.4146 3.59402 16.1582 3.17577 15.7412 2.75879C15.3242 2.34184 14.906 2.08539 14.4128 1.89376C13.9357 1.70834 13.3905 1.58154 12.5922 1.54513C11.7923 1.50863 11.5369 1.5 9.50002 1.5ZM9.50002 2.85135C11.5026 2.85135 11.7398 2.859 12.5306 2.89508C13.2619 2.92843 13.659 3.05061 13.9233 3.15332C14.2734 3.28937 14.5232 3.4519 14.7856 3.71436C15.0481 3.97679 15.2106 4.22663 15.3467 4.57671C15.4494 4.84099 15.5716 5.23811 15.6049 5.96936C15.641 6.7602 15.6487 6.99742 15.6487 9.00002C15.6487 11.0026 15.641 11.2398 15.6049 12.0306C15.5716 12.7619 15.4494 13.159 15.3467 13.4233C15.2106 13.7734 15.0481 14.0232 14.7856 14.2856C14.5232 14.5481 14.2734 14.7106 13.9233 14.8467C13.659 14.9494 13.2619 15.0716 12.5306 15.1049C11.7399 15.141 11.5027 15.1487 9.50002 15.1487C7.49727 15.1487 7.26011 15.141 6.46936 15.1049C5.73812 15.0716 5.341 14.9494 5.07672 14.8467C4.72664 14.7106 4.47679 14.5481 4.21436 14.2856C3.95193 14.0232 3.78938 13.7734 3.65332 13.4233C3.55061 13.159 3.42843 12.7619 3.39508 12.0306C3.359 11.2398 3.35135 11.0026 3.35135 9.00002C3.35135 6.99742 3.359 6.7602 3.39508 5.96936C3.42843 5.23811 3.55061 4.84099 3.65332 4.57671C3.78938 4.22663 3.9519 3.97679 4.21436 3.71436C4.47679 3.4519 4.72664 3.28937 5.07672 3.15332C5.341 3.05061 5.73812 2.92843 6.46936 2.89508C7.2602 2.859 7.49742 2.85135 9.50002 2.85135Z"
        fill="url(#paint4_linear_192_5983)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50002 1.5C7.46312 1.5 7.20771 1.50863 6.40776 1.54513C5.60947 1.58154 5.06427 1.70834 4.58722 1.89376C4.09402 2.08539 3.67577 2.34184 3.25879 2.75879C2.84184 3.17577 2.58539 3.59402 2.39376 4.08722C2.20834 4.56427 2.08154 5.10947 2.04513 5.90776C2.00863 6.70771 2 6.96312 2 9.00002C2 11.0369 2.00863 11.2923 2.04513 12.0922C2.08154 12.8905 2.20834 13.4357 2.39376 13.9128C2.58539 14.406 2.84184 14.8242 3.25879 15.2412C3.67577 15.6582 4.09402 15.9146 4.58722 16.1063C5.06427 16.2917 5.60947 16.4185 6.40776 16.4549C7.20771 16.4914 7.46312 16.5 9.50002 16.5C11.5369 16.5 11.7923 16.4914 12.5922 16.4549C13.3905 16.4185 13.9357 16.2917 14.4128 16.1063C14.906 15.9146 15.3242 15.6582 15.7412 15.2412C16.1582 14.8242 16.4146 14.406 16.6063 13.9128C16.7917 13.4357 16.9185 12.8905 16.9549 12.0922C16.9914 11.2923 17 11.0369 17 9.00002C17 6.96312 16.9914 6.70771 16.9549 5.90776C16.9185 5.10947 16.7917 4.56427 16.6063 4.08722C16.4146 3.59402 16.1582 3.17577 15.7412 2.75879C15.3242 2.34184 14.906 2.08539 14.4128 1.89376C13.9357 1.70834 13.3905 1.58154 12.5922 1.54513C11.7923 1.50863 11.5369 1.5 9.50002 1.5ZM9.50002 2.85135C11.5026 2.85135 11.7398 2.859 12.5306 2.89508C13.2619 2.92843 13.659 3.05061 13.9233 3.15332C14.2734 3.28937 14.5232 3.4519 14.7856 3.71436C15.0481 3.97679 15.2106 4.22663 15.3467 4.57671C15.4494 4.84099 15.5716 5.23811 15.6049 5.96936C15.641 6.7602 15.6487 6.99742 15.6487 9.00002C15.6487 11.0026 15.641 11.2398 15.6049 12.0306C15.5716 12.7619 15.4494 13.159 15.3467 13.4233C15.2106 13.7734 15.0481 14.0232 14.7856 14.2856C14.5232 14.5481 14.2734 14.7106 13.9233 14.8467C13.659 14.9494 13.2619 15.0716 12.5306 15.1049C11.7399 15.141 11.5027 15.1487 9.50002 15.1487C7.49727 15.1487 7.26011 15.141 6.46936 15.1049C5.73812 15.0716 5.341 14.9494 5.07672 14.8467C4.72664 14.7106 4.47679 14.5481 4.21436 14.2856C3.95193 14.0232 3.78938 13.7734 3.65332 13.4233C3.55061 13.159 3.42843 12.7619 3.39508 12.0306C3.359 11.2398 3.35135 11.0026 3.35135 9.00002C3.35135 6.99742 3.359 6.7602 3.39508 5.96936C3.42843 5.23811 3.55061 4.84099 3.65332 4.57671C3.78938 4.22663 3.9519 3.97679 4.21436 3.71436C4.47679 3.4519 4.72664 3.28937 5.07672 3.15332C5.341 3.05061 5.73812 2.92843 6.46936 2.89508C7.2602 2.859 7.49742 2.85135 9.50002 2.85135Z"
        fill="url(#paint5_radial_192_5983)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_192_5983"
          x1="2.8752"
          y1="2.28859"
          x2="7.60457"
          y2="20.5824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_192_5983"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.54115 16.5) rotate(32.1601) scale(14.0092 10.082)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_192_5983"
          x1="2.8752"
          y1="2.28859"
          x2="7.60457"
          y2="20.5824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_192_5983"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.54115 16.5) rotate(32.1601) scale(14.0092 10.082)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_192_5983"
          x1="2.8752"
          y1="2.28859"
          x2="7.60457"
          y2="20.5824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_192_5983"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.54115 16.5) rotate(32.1601) scale(14.0092 10.082)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
      </defs>
    </svg>
  );
}

const MemoInstagram = React.memo(Instagram);
export default MemoInstagram;
